<template>
  <div>
    <div class="index-bottom fcc">
      <div class="fcc w-1200">
        <div class="w312">
          <p class="t14 tff mr26" v-html="arr[0].name"></p>
          <div class="">
            <div class="mr-18 sub-companies flex-around">
              <div
                class="mr-b5 content hover"
                v-for="(item, index) in arr[0].title"
                :key="index"
                @click="toDetail(item)"
              >
                {{ item.title }}
              </div>
            </div>
<!--            <div class="mr-18">-->
<!--              <div-->
<!--                class="mr-b5"-->
<!--                v-for="(item, index) in arr[0].title"-->
<!--                :key="index"-->
<!--              >-->
<!--                {{ item.text }}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div>-->
<!--              <div-->
<!--                class="mr-b5"-->
<!--                v-for="(item, index) in arr[0].title"-->
<!--                :key="index"-->
<!--              >-->
<!--                {{ item.text }}-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
        <!-- 第二部分 -->
        <div class="w312 fcc">
          <div>
            <p class="t14 tff mr26" v-html="arr[1].name"></p>
            <div
              class="mr-b5 hover"
              v-for="(item, index) in arr[1].title"
              :key="index"
              @click="toSite(item.target)"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <!-- 第三部分 -->
        <div class="w364 fcc">
          <div>
            <p class="t14 tff mr26" v-html="arr[2].name"></p>
            <div class="flex">
              <img class="img" src="../images/形状 604.png" alt="/" />
              <p class="w229">
                地址：四川省成都市青羊区总部经济基地一
                期新兴产业示范大厦1号楼B座8层
              </p>
            </div>
            <div class="flex mr22">
              <img class="img" src="../images/形状 611.png" alt="/" />
              <p>电话：+86-028-87779788</p>
            </div>
            <div class="flex">
              <img class="img" src="../images/形状 615.png" alt="/" />
              <p>传真：+86-028-87779788</p>
            </div>
          </div>
        </div>
        <!-- 第四 -->
        <div class="w210 t14 t66">
          <div class="fcb">
            <div>
              <img src="../images/video-qrcode.png" alt="/" />
              <p class="fcc h12">视频号</p>
            </div>
            <div>
              <img src="../images/video-qrcode.png" alt="/" />
              <p class="fcc h12">微信公众号</p>
            </div>
          </div>
          <div class="bottom fcc mr16">
            <img class="mr7" src="../images/形状 717.png" alt="/" />
            <p>网站投稿</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-text fcc t14">
      © 四川省国新联程物流集团有限公司 版权所有 ALL RIGHTS RESERVED.
      <span class="record" @click="toRecord">蜀ICP备17008901号-1</span>
    </div>
  </div>
</template>
<script>
import {getSubCompanies} from '@/api'
export default {
  name: "index-bottom",
  data() {
    return {
      arr: [
        {
          name: "下属公司",
          title: [
            {
              text: "供应链股份公司",
            },
            {
              text: "攀枝花公司",
            },
            {
              text: "成乐公司",
            },
            {
              text: "石化公司",
            },
            {
              text: "电商公司",
            },
          ],
        },
        {
          name: "友情链接",
          title: [
            {
              text: "川煤集团",
              target: 'https://www.cmjt.com.cn'
            },
            {
              text: "四川省物流产业股份有限公司",
              target: 'http://www.chanwo.sc.cn/'
            },
            {
              text: "陕西延长石油集团四川销售有限公司",
              target: 'https://www.sxycpc.com/'
            },
            {
              text: "河北道桥交通设计研究院有限公司",
              // target: 'http://www.zhwjtjs.com'
              target: ''
            },
            {
              text: "四川德胜集团钒钛有限公司",
              target: 'http://www.scdesheng.com/'
            },
          ],
        },
        {
          name: "联系我们",
        },
      ],
    };
  },
  async mounted() {
    const result = await getSubCompanies()
    this.arr[0].title = result.data[0].content
  },
  methods: {
    toSite(url) {
      if(url) {
        window.open(url)
      }``
    },
    toRecord() {
      window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery')
    },
    toDetail(item) {
      const resolver  = this.$router.resolve({
        path: `/news/detail/${item.id}`
      })
      window.open(resolver.href)
    }
  }
};
</script>
<style scoped>
.bottom-text {
  width: 100%;
  height: 40px;
  background: #071b34;
  color: #c9c9c9;
}
.h12 {
  height: 12px;
}
.mr16 {
  margin-top: 10px;
}
.mr7 {
  margin-right: 7px;
}
.bottom {
  width: 100px;
  height: 38px;
  background: #ffffff;
  opacity: 0.9;
  border-radius: 6px;
  position: relative;
  left: 110px;
}
.w210 {
  width: 210px;
}
.img {
  width: 16px;
  height: 16px;
  margin-right: 7px;
}
.mr22 {
  margin: 22px 0;
}
.w229 {
  width: 229px;
}
.w364 {
  width: 364px;
}
.flex {
  display: flex;
}
.mr-18 {
  margin-right: 18px;
}
.mr-b5 {
  margin-bottom: 8px;
}
.mr26 {
  margin-bottom: 26px;
}
.w312 {
  width: 312px;
  border-right: 1px solid rgba(250, 250, 250, 0.1);
}
.index-bottom {
  background-image: url(../images/bottom.png);
  height: 266px;
  margin-top: 80px;
  border-bottom: 1px dashed #a3b2c4;
  color: #c9c9c9;
  padding: 50px 0;
  box-sizing: border-box;
}
.record:hover {
  text-decoration: underline;
  cursor: pointer;
}
.flex-around {
  display: flex;
  flex-wrap: wrap;
}
.content {
  width: 95px;
}
.hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
